import { render, staticRenderFns } from "./PropSelector.vue?vue&type=template&id=673c4889&scoped=true&"
import script from "./PropSelector.vue?vue&type=script&lang=js&"
export * from "./PropSelector.vue?vue&type=script&lang=js&"
import style0 from "./PropSelector.vue?vue&type=style&index=0&id=673c4889&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673c4889",
  null
  
)

export default component.exports